import StorageService from '@/services/storage.service'
import storageKeys from '@/constans/storageKeys'
import { defaultFilters } from '@/models/KlnAssessment/helpers'
import klnAssessmentRepository from '@/repository/admin/klnAssessmentRepository'
import TableOptions from '@/models/TableOptions'
import { omitEmptyDeepFilters, prepareFilters } from '@/helpers/filters'
import i18n from '@/plugins/vue-i18n'
import { DATE_MONTH_FORMAT } from '@/constans/date'
import { formatDate } from '@/helpers/date'
const { saveAs } = require('file-saver')

const state = {
  filters: StorageService.get(storageKeys.KLN_ASSESSMENT_FILTERS) || { ...defaultFilters },
  klnAssessmentList: [],
  tableOptions: TableOptions.defaultTableOptions(),
}

const getters = {
  filters: state => state.filters,
  tableOptions: state => state.tableOptions,
  klnAssessmentList: state => state.klnAssessmentList,
  isOpenFilterPanel: state =>
    state.filters.clientOptions && state.filters.clientOptions.filterPanelExpanded,
}

const actions = {
  async loadKlnAssessmentList(context, filters) {
    context.commit('setFilters', filters)
    StorageService.set(storageKeys.KLN_ASSESSMENT_FILTERS, filters)

    const appliedFilters = omitEmptyDeepFilters(filters.filter)
    const appliedCfFilters = omitEmptyDeepFilters(filters.cfFilter)
    const appliedCustomFilters = omitEmptyDeepFilters(filters.custom_filter)

    const preparedFilters = prepareFilters({
      ...filters,
      filter: appliedFilters,
      cfFilter: appliedCfFilters,
      custom_filter: appliedCustomFilters,
    })

    const { data } = await klnAssessmentRepository.list(preparedFilters)

    context.commit('setKlnAssessmentList', { data, filters })

    return { klnAssessmentList: data.items, pagination: data.pagination }
  },
  async loadKlnAssessment(context, id) {
    const { data } = await klnAssessmentRepository.get(id)
    return data
  },
  createKlnAssessment(context, payload) {
    return klnAssessmentRepository.post(payload)
  },
  updateKlnAssessment(context, payload) {
    const { id, ...data } = payload
    return klnAssessmentRepository.put(id, data)
  },
  deleteKlnAssessment(context, payload) {
    const { id, ...data } = payload
    return klnAssessmentRepository.put(id, data)
  },
  filtersStorageReset() {
    StorageService.remove(storageKeys.KLN_ASSESSMENT_FILTERS)
  },
  updateFiltersClientOptions({ commit, getters }, clientOptions) {
    const updatedFilters = {
      ...getters.filters,
      clientOptions,
    }
    commit('setFilters', updatedFilters)
    StorageService.set(storageKeys.KLN_ASSESSMENT_FILTERS, updatedFilters)
  },
  async loadExportFile(context, filters) {
    const appliedFilters = omitEmptyDeepFilters(filters.filter)
    const appliedCfFilters = omitEmptyDeepFilters(filters.cfFilter)

    const preparedFilters = prepareFilters({
      ...filters,
      filter: appliedFilters,
      cfFilter: appliedCfFilters,
    })

    const response = await klnAssessmentRepository.export(preparedFilters)
    const blob = new Blob([response.data], { type: response.headers['content-type'] })
    const filename = `${i18n.tc('klnAssessment.title')}${
      appliedFilters?.month
        ? ` ${formatDate(appliedFilters.month.value.split('|')[0], DATE_MONTH_FORMAT)}`
        : ''
    }.xlsx`
    saveAs(blob, filename)
    return response
  },
}

const mutations = {
  setKlnAssessmentList(state, { data, filters }) {
    state.klnAssessmentList = [...data.items]
    state.tableOptions = new TableOptions(data.pagination, filters)
  },
  setFilters(state, filters) {
    state.filters = { ...filters }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
